import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';

export const backToTopButtonCss = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 50,
  height: 50,
  backgroundColor: colorsPalette.red,
  color: colorsPalette.white,
  border: 0,
  borderRadius: '50%',
  transform: 'rotate(-90deg)',
  transformOrigin: 'center center',
  pointerEvents: 'all',
  cursor: 'pointer',

  ':hover': {
    backgroundColor: colorsPalette.grey,
  },
});

export const backToTopIconCss = css({
  fontSize: 18,
});
